import { render } from "./AllProcesses.vue?vue&type=template&id=3868aa90&scoped=true"
import script from "./AllProcesses.vue?vue&type=script&lang=js"
export * from "./AllProcesses.vue?vue&type=script&lang=js"

import "./AllProcesses.vue?vue&type=style&index=0&id=3868aa90&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3868aa90"]])

export default __exports__